import React from 'react';
import PropTypes from 'prop-types';
import i18n from '@wix/wix-vod-shared/src/common/i18n';
import Info from '@wix/wix-vod-shared/src/widget/vod-player/components/info/info';

import settings from '@wix/wix-vod-shared/src/common/settings';

import sharedTranslations from 'messages/shared';
import translations from 'messages/widget';

class VideoInfo extends React.Component {

  static propTypes = {
    posterUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    publisher: PropTypes.string,
    durationStr: PropTypes.string,
    durationAriaLabel: PropTypes.string,
    genre: PropTypes.string,
    videoType: PropTypes.string,
    cast: PropTypes.array,
    crew: PropTypes.array,
    isPlayerInFullScreen: PropTypes.bool,
  };

  translateCrew(crew) {
    // eslint-disable-next-line arrow-parens
    return _.map(crew, (crewMember) => {
      const { role } = crewMember;

      if (!role || !sharedTranslations[role]) {
        return crewMember;
      }

      return {
        ...crewMember,
        role: i18n.t(sharedTranslations[role]),
      };
    });
  }

  translateGenre(genre) {
    if (!genre || !sharedTranslations[genre]) {
      return null;
    }

    return i18n.t(sharedTranslations[genre]);
  }

  translateVideoType(videoType) {
    if (!videoType || !sharedTranslations[videoType]) {
      return null;
    }

    return i18n.t(sharedTranslations[videoType]);
  }

  translatePublisher(publisher) {
    if (!publisher) {
      return null;
    }

    return i18n.t(translations.publisher, { author: publisher });
  }

  render() {
    const {
      posterUrl,
      title,
      description,
      publisher,
      durationStr,
      durationAriaLabel,
      genre,
      videoType,
      cast,
      crew,
      isPlayerInFullScreen,
    } = this.props;

    return (
      <Info title={title}
            description={description}
            posterUrl={posterUrl}
            durationStr={durationStr}
            durationAriaLabel={durationAriaLabel}
            publisher={this.translatePublisher(publisher)}
            genre={this.translateGenre(genre)}
            videoType={this.translateVideoType(videoType)}
            cast={cast}
            crew={this.translateCrew(crew)}
            crewTitle={i18n.t(translations.crew)}
            castTitle={i18n.t(translations.cast)}
            isInFullScreen={isPlayerInFullScreen}
            imageHost={settings.hosts.image} />
    );
  }
}

export default VideoInfo;



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/video-info/video-info.js